import { TApiServiceOptions, ApiService } from "../apiService";
import { API } from "../../core/apiurl";
import { TVersionResponse } from "./version.types";

const apiService = new ApiService();

class VersionService {
  getVersion(options?: TApiServiceOptions) {
    return apiService.get<TVersionResponse>(API.version, options);
  }
}

export const versionService = new VersionService();
